import VueTypes from 'vue-types'
/**
 * 弹框默认属性
 * @param {Sring} id 弹框的唯一id 使用者不用传 只有confirm 函数调用时会自动生成
 * @param {String} type 弹框的类型 只有 modal 和 confirm 使用者也不用传
 * @param {String} color 弹框颜色主题  用于自定义样式
 * @param {String} title 弹框标题
 * @param {Boolean} maskClickClose 是否可通过点击遮罩关闭弹框
 * @param {Boolean} needClose 是否需要关闭按钮
 * @param {Boolean} needCancelBtn 是否需要取消按钮
 * @param {String} transition 弹框内容过渡动画名称
 * @param {String} cancelBtnColor 取消按钮颜色
 * @param {String} okBtnColor 确认按钮颜色
 * @param {String} btnSize 按钮大小
 * @param {String} cancelBtnLabel 取消按钮文本
 * @param {String} okBtnLabel 确认按钮文本
 * @param {Boolean} loading 点击确认按钮是否需要 loading 等待
 * @param {Boolean} needBtn 是否需要按钮们
 * @param {Boolean} autoClose 点击确认按钮是否自动关闭
 */
export default {
  id: VueTypes.string.def(''),
  type: VueTypes.oneOf(['modal', 'confirm']).def('modal'),
  color: VueTypes.string.def('base'),
  title: VueTypes.string.def(''),
  maskClickClose: VueTypes.bool.def(true),
  needClose: VueTypes.bool.def(true),
  needCancelBtn: VueTypes.bool.def(true),
  transition: VueTypes.string.def('fade'),
  cancelBtnColor: VueTypes.string.def('white'),
  okBtnColor: VueTypes.string.def('blue'),
  btnSize: VueTypes.string.def('normal'),
  cancelBtnLabel: VueTypes.string.def('取消'),
  okBtnLabel: VueTypes.string.def('确定'),
  loading: VueTypes.bool.def(false),
  needBtn: VueTypes.bool.def(true),
  autoClose: VueTypes.bool.def(true)
}
